module.exports = __webpack_public_path__ + "static/media/potential-3.df884798.svg";